import { render } from "./EditTeknologi.vue?vue&type=template&id=3370485e"
import script from "./EditTeknologi.vue?vue&type=script&lang=js"
export * from "./EditTeknologi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__